__turbopack_context__.v({
  "className": "caveat_87f5788b-module__UTBJIq__className",
});
